import type { CiaDependencies } from '~/composables/useCia/types';
import { BLOOMREACH_COOKIE } from '~~/constants/bloomreach';
import { getFirstCookieValue } from '~~/helpers/cookies/getFirstCookieValue';

type CustomerUpdateRequest = {
  locale: string;
  cookie?: string;
  user_id?: string;
  email?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, cookies, languageAndCountry } = dependencies;

  return async (userId?: string): Promise<unknown> => {

    if (!userId) {

      return Promise.resolve();
    
    }

    const payload: CustomerUpdateRequest = {
      locale: languageAndCountry,
      cookie: getFirstCookieValue(cookies?.get(BLOOMREACH_COOKIE)),
      user_id: userId,
    };

    return fetch('/cia/customer-update', {
      method: 'POST',
      body: payload,
    });
  
  };

};
